import { Component } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import PageCustomizableContainer from 'hb-react/shared/apps/PageCustomizables/containers/PageCustomizableContainer';
import useFeatureFlag from 'hb-react/shared/hooks/useFeatureFlag';

import PageCustomizablesAppClientV2 from './v2';

class PageCustomizablesAppClient extends Component {
  generateRoute(page) {
    const {
      app,
      headerVisible,
      ids,
      fetchPath,
      legacyContentClassName,
      networkRootUrl,
      subdomainNetworkUrl,
      topic,
    } = this.props;

    return (
      <Route
        key={page.slug}
        path={page.slug}
        element={
          <PageCustomizableContainer
            app={app || 'frontoffice'}
            headerVisible={headerVisible}
            ids={ids}
            legacyContentClassName={
              legacyContentClassName ||
              'container--centered soft-double--ends soft--sides'
            }
            networkRootUrl={networkRootUrl}
            subdomainNetworkUrl={subdomainNetworkUrl}
            topic={topic}
            url={fetchPath(page.slug)}
          />
        }
      />
    );
  }

  renderRoutes = () => {
    const { appPages } = this.props;
    const pages = [];

    if (appPages) {
      appPages.map((page) => {
        if (page.menu.feature_name == null) {
          pages.push(this.generateRoute(page.menu));
        }

        return page.submenus.forEach((subPage) => {
          if (subPage.feature_name == null) {
            pages.push(this.generateRoute(subPage));
          }
        });
      });

      return pages;
    }
  };

  render() {
    const { appPages, redirectUrl } = this.props;

    return (
      <Routes>
        {this.renderRoutes()}
        {appPages && <Route path="*" element={<Navigate to={redirectUrl} />} />}
      </Routes>
    );
  }
}

export default (props) => {
  const { flagUePerfMenuItem } = useFeatureFlag();

  return flagUePerfMenuItem ? (
    <PageCustomizablesAppClientV2 {...props} />
  ) : (
    <PageCustomizablesAppClient {...props} />
  );
};
